//导入axios
import axios from "axios";

//导入token获取方法
import {getToken} from "../utils/token"

//导入element-ui的弹框
// import {Message} from 'element-ui'

//自定义添加axios实例对象
const instance =axios.create({
  //自定义响应axios实例对象
  // baseURL:"https://csvip.club/api",
  // baseURL:"https://csvip.club/api",//前台跳转9个页面路径
  baseURL:"https://csvip.club/api",//后台两个页面
})
//统一设置 跨域携带cookie
//  axios.defaults.withCredentials = true

//统一设置axios拦截器
//请求拦截器-----------------------------------------------------------------------
//在请求发送之前
//config是当前这次请求的 各种设置
//可以统一设置header
instance.interceptors.request.use(config => {
    // config.interceptors = '请求拦截器'
    //为config统一设置token
    config.headers.Authorization=getToken();
    return config
  }, function(error) {
     //处理请求拦截器中的错误信息
     return Promise.reject(error)
  })

// 响应拦截器-------------------------------------------------------------------------
// axios 直接使用的.then之前
// response 服务器响应的内容
instance.interceptors.response.use(
    function(response) {
      // 如果状态码为200 成功
      if (response.data.code === 200) {
        // Message.success(response.data.message);
      }
      return response;
    },
    function(error) {
      return Promise.reject(error);
    }
  );


  export default instance;

